var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "20-Email-Write") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_20-Email-Write",
    "data-name": "20-Email-Write"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,3H3A3,3,0,0,0,0,6V24a3,3,0,0,0,3,3H16V25H3a1,1,0,0,1-1-1V6.23l13.42,9.58a1,1,0,0,0,1.16,0L30,6.23V15h2V6A3,3,0,0,0,29,3ZM16,13.77,3.72,5H28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,15H22a1,1,0,0,0-1,1V26a1,1,0,0,0,.29.71l2,2a1,1,0,0,0,1.41,0l2-2A1,1,0,0,0,27,26V16A1,1,0,0,0,26,15ZM25,25.59l-1,1-1-1V21h2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9c4ebc48f033e13776c62f5591ce8e06.svg";
export { ForwardRef as ReactComponent };